import { css, keyframes, SerializedStyles } from '@emotion/core';
import { styled } from '@material-ui/core/styles';
import { Card as MuiCard, Typography } from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRightAlt';

import { ICustomTheme } from 'interfaces';

type Theme = { theme: ICustomTheme };

const getPulse = (theme: ICustomTheme) =>
  keyframes({
    from: {
      backgroundColor: theme.palette.grey[100],
    },
    to: {
      backgroundColor: theme.palette.grey[200],
    },
  });

export const getSkeletonCss =
  (height: number) =>
  (theme: ICustomTheme): SerializedStyles =>
    css({
      animation: `${getPulse(theme)} 600ms 500ms alternate both infinite`,
      boxShadow: 'none',
      height,
    });

export const ArrowIcon = styled(ArrowRightIcon)(
  ({ theme }: { theme: ICustomTheme }) => ({
    fontSize: theme.typography.h2.fontSize,
    marginLeft: theme.spacing(1),
  }),
);

export const StyledCard = styled(MuiCard)(
  ({ theme, isMobile }: { theme: ICustomTheme; isMobile: boolean }) => ({
    margin: isMobile ? theme.spacing(0) : theme.spacing(2, 2),
    padding: isMobile ? '1.6rem' : '3.2rem',
  }),
);

export const Date = styled(Typography)(
  ({ theme }: { theme: ICustomTheme }) => ({
    paddingTop: '0.8rem',
    color: theme.colors.grey.light,
    fontStyle: 'italic',
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: '1.6rem',
  }),
);

export const Description = styled(Typography)(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.grey.dark,
    fontSize: '1.8rem',
    lineHeight: theme.typography.h4.lineHeight,
  }),
);

export const LinkTextWrapper = styled('span')(
  ({ theme }: { theme: ICustomTheme }) => ({
    color: theme.colors.paletteFromBO.primary,
    alignItems: 'center',
    display: 'flex',
    fontSize: '2.0rem',
  }),
);

export const Subtitle = styled(Typography)(
  ({ theme }: { theme: ICustomTheme }) => ({
    paddingTop: '0.8rem',
    color: theme.colors.paletteFromBO.main,
    fontSize: '1.8rem',
    fontWeight: theme.typography.fontWeightBold,
  }),
);

export const Title = styled('div')(({ theme }: { theme: ICustomTheme }) => ({
  paddingTop: '2.4rem',
  color: theme.colors.grey.dark,
  fontSize: '2.3rem',
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase',
}));

export const StyledImage = styled('img')(() => ({
  height: 'auto',
  width: '100%',
  display: 'block',
}));

export const StyledTitleAndDateContainer = styled('div')(
  ({ isMobile }: { isMobile: boolean }) => ({
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    justifyContent: isMobile ? 'flex-start' : 'space-between',
    alignItems: isMobile ? 'flex-start' : 'center',
    flexWrap: 'wrap',
  }),
);

export const StyledLinkContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
}));
